/* eslint-disable no-console */
import { register } from 'register-service-worker'

const isProd =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD) ||
  process.env.NODE_ENV === 'production'

// BASE_URL compatible (Vite usa import.meta.env.BASE_URL, Vue CLI usa process.env.BASE_URL)
const baseUrl =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.BASE_URL) ||
  process.env.BASE_URL ||
  '/'

if (isProd) {
  register(`${baseUrl}service-worker.js`, {
    ready (registration) {
      console.log('App served from cache by a service worker.', registration)
    },
    registered (registration) {
      console.log('Service worker has been registered.', registration)
    },
    cached (registration) {
      console.log('Content has been cached for offline use.', registration)
    },
    updatefound (registration) {
      console.log('New content is downloading.', registration)
    },
    updated (registration) {
      console.log('New content is available; dispatching swUpdated event.', registration)

      // 👇 Despierta el modal SOLO si hay un SW esperando
      if (registration && registration.waiting) {
        window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }))
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // 👇 Cuando el SW cambie (después de SKIP_WAITING) recarga la página una sola vez
  let refreshing = false
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })
}
